import { render, staticRenderFns } from "./SchoolPeopleList.vue?vue&type=template&id=64b1d588&scoped=true"
import script from "./SchoolPeopleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchoolPeopleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SchoolPeopleList.vue?vue&type=style&index=0&id=64b1d588&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b1d588",
  null
  
)

export default component.exports